'use strict';

var $ = require('jquery');
var colorbox = require('../lib/plaudit.colorbox.js');
var siteLightboxOptions = require('./siteLightboxOptions.js');

function init() {
	if ($('#announcement').length === 0) {
		return;
	}

	function getCookie(cookieName) {
		var name = cookieName + "=";
		var decodedCookie = decodeURIComponent(document.cookie);
		var ca = decodedCookie.split(';');
		for(var i = 0; i <ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0) == ' ') {
				c = c.substring(1);
			}
			if (c.indexOf(name) == 0) {
				return c.substring(name.length, c.length);
			}
		}
		return null;
	}

	if (!getCookie('showAnnouncement')) {
		var options = $.extend({}, siteLightboxOptions.options(), {
			className: 'announcementLightbox',
			inline: true,
			href: '#announcement',
			maxWidth: '500px',
			onClosed: function() {
				var duration = 24*60*60*1000; // 1 day
				var date = new Date();
				date.setTime(date.getTime()+duration);
				document.cookie = `showAnnouncement=false; expires=${date.toUTCString()}; path=/`;
			}
		});

		function triggerLightbox() {
			$.colorbox(options);
		}

		var $announcementImage = $('.announcement__image img');
		if ($announcementImage.length > 0) {
			// Wait for image (or cached image) to load
			// https://stackoverflow.com/questions/4857896/jquery-callback-after-all-images-in-dom-are-loaded
			if ($announcementImage.complete) {
				triggerLightbox.call($announcementImage);
			} else {
				$announcementImage.on('load', triggerLightbox);
			}
		} else {
			triggerLightbox();
		}
	}
}

module.exports = {
	init: init
}
